var moduleMap = {
	"./ChartPage": () => {
		return Promise.all([__webpack_require__.e(794), __webpack_require__.e(285), __webpack_require__.e(518), __webpack_require__.e(867), __webpack_require__.e(206), __webpack_require__.e(527), __webpack_require__.e(929), __webpack_require__.e(173), __webpack_require__.e(674), __webpack_require__.e(684), __webpack_require__.e(464)]).then(() => (() => ((__webpack_require__(9684)))));
	},
	"./AppWithProviders": () => {
		return Promise.all([__webpack_require__.e(794), __webpack_require__.e(285), __webpack_require__.e(518), __webpack_require__.e(393), __webpack_require__.e(527), __webpack_require__.e(929), __webpack_require__.e(173), __webpack_require__.e(450), __webpack_require__.e(674), __webpack_require__.e(688), __webpack_require__.e(926)]).then(() => (() => ((__webpack_require__(189)))));
	},
	"./AssetMarket": () => {
		return Promise.all([__webpack_require__.e(794), __webpack_require__.e(285), __webpack_require__.e(527), __webpack_require__.e(259), __webpack_require__.e(929), __webpack_require__.e(674), __webpack_require__.e(650)]).then(() => (() => ((__webpack_require__(2876)))));
	},
	"./Footer": () => {
		return Promise.all([__webpack_require__.e(794), __webpack_require__.e(527), __webpack_require__.e(269)]).then(() => (() => ((__webpack_require__(8269)))));
	},
	"./Navbar": () => {
		return Promise.all([__webpack_require__.e(527), __webpack_require__.e(450), __webpack_require__.e(528)]).then(() => (() => ((__webpack_require__(9687)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});